import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { clearModalData, toggleModal } from '../../Modal/modalActions';
import UserRouteForm from './UserForm/UserRouteForm.js';
import { getDataByUniqueModalName } from '../../Modal/modalViewState';
import { getMerchants } from '../../Merchants/merchantsEntity';
import { getMerchants as getPaymentMerchants } from '../../MerchantManagement/merchantManagementEntity';
import { editRules } from '../UserRoutingRules/RoutingRules/rulesActions';
import { getEditRulesErrorMessage, getIsEditRulesLoading, getIsEditRulesSuccessful } from '../UserRoutingRules/RoutingRules/rulesEntity';
import { merchantShape } from '../../../utils/propTypes';
import { getUsers } from '../../UserManagement/userManagementEntity';

export class EditRule extends Component {
    static propTypes = {
        rules: PropTypes.array.isRequired,
        rule: PropTypes.any,
        username: PropTypes.string,
        users: PropTypes.array,
        onToggleModal: PropTypes.func.isRequired,
        onEditUserRules: PropTypes.func.isRequired,
        clearModalData: PropTypes.func.isRequired,
        merchants: PropTypes.arrayOf(merchantShape),
        paymentMerchants: PropTypes.array,
        isEditRulesLoading: PropTypes.bool,
        isEditRulesSuccessful: PropTypes.bool,
        editRulesErrorMessage: PropTypes.string
    };

    static defaultProps = {
        rules: []
    };

    getUserMerchantIds = () => {
        let merchantIds = _.get(_.find(this.props.users, (user) => {
            return user.userName === this.props.username;
        }), 'accessRights.merchantIds');

        return Object.keys(merchantIds || {});
    };

    getMerchants = () => {
        return _.filter(this.props.merchants, (merchant) => {
            return _.includes(this.getUserMerchantIds(), merchant.merchantId);
        });
    };

    getPaymentMerchants = () => {
        return _.filter(this.props.paymentMerchants, (merchant) => {
            return _.includes(this.getUserMerchantIds(), merchant.merchantId);
        });
    };

    handleOnSubmit = (rule) => {
        const updatedRules = _.cloneDeep(this.props.rules);

        if (!_.isEmpty(rule)) {
            updatedRules.push(rule);
        }

        this.props.onEditUserRules(this.props.username, updatedRules);
    };

    render() {
        return (<UserRouteForm
            className="edit-rule-form"
            modalTitle="Edit Routing Rule"
            uniqueModalName="editRule"
            onSubmit={this.handleOnSubmit}
            rule={this.props.rule}
            rules={this.props.rules}
            merchants={this.getMerchants()}
            paymentMerchants={this.getPaymentMerchants()}
            isEditRulesLoading={this.props.isEditRulesLoading}
            isEditRulesSuccessful={this.props.isEditRulesSuccessful}
            clearRule={this.props.clearModalData}
        />);
    }
}

export function mapStateToProps(state) {
    const { rules, rule, username } = getDataByUniqueModalName(state, 'editRule') || {};

    const remainingRules = _.without(rules, rule);

    return {
        username,
        users: getUsers(state),
        rule,
        rules: remainingRules,
        merchants: getMerchants(state),
        paymentMerchants: getPaymentMerchants(state),
        isEditRulesSuccessful: getIsEditRulesSuccessful(state),
        isEditRulesLoading: getIsEditRulesLoading(state),
        editRulesErrorMessage: getEditRulesErrorMessage(state)
    };
}

export function mapDispatchToProps(dispatch) {
    return {
        onToggleModal: () => dispatch(toggleModal('editRule', undefined)),
        clearModalData: () => dispatch(clearModalData('editRule')),
        onEditUserRules: (username, rules) => dispatch(editRules(username, rules))
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(EditRule);
